<template>
  <div>
    <el-page-header @back="goBack" content="详情"></el-page-header>
    <div class="dailyDetails">
      <myTable
        :loading="loading"
        :tableData="tableData"
        :tableHeader="tableHeader"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "dailyDetails",
  data() {
    return {
      loading: false,
      tableData: [],
      tableHeader: Object.freeze([
        {
          name: "标题",
          prop: "title",
        },
        {
          name: "来源",
          prop: "createUnit",
        },
      ]),
    };
  },
  created() {
    // 解析文章数据
    this.tableData = JSON.parse(this.$route.query.doc) || [];
  },
  methods: {
    goBack() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.dailyDetails {
  margin-top: 20px;
}
</style>
